import type { BookingTranslations } from "../../../pt-BR/event/booking";

export const BOOKING_FR_FR: BookingTranslations = {
	reserve: {
		label: "Forfaits",
		search: "Rechercher des forfaits",
		create: "Créer un forfait",
		empty: {
			title: "Aucun forfait pour cet événement",
			subtitle:
				"Créez votre premier forfait en cliquant sur le bouton ¨Créer un forfait¨ en haut de cette page",
		},
		reserveCard: {
			guests: "{{count}} invités",
			promotions: "{{count}} promotions",
			none: "Aucune promotion sélectionnée",
			people: "{{count}} personnes confirmées",
		},
		reserveDetail: {
			title: "Forfait de",
			confirmed: "{{count}} confirmés",
			of: "de",
			guestsCount: "{{count}} invités",
			delete: "Êtes-vous sûr de vouloir supprimer ce produit?",
			promotions: "Promotions forfaitaires",
			none: "Aucune promotion sélectionnée",
			guests: "Invités",
			invoices: "Factures générées",
			invoiceIssuingLabel: "Émission de la facture en cours...",
			invoiceCanceledLabel: "Facture annulée",
			invoiceErrorLabel: "Erreur d'émission de la facture",
			invoiceModeLabel: "Mode d'emission:",
			value: "Valeur du forfait",
			issueInvoice: "Émettre une facture",
			copyModal: {
				defaultReserveName: "Copie de {{name}}",
				title: "Créer une copie du forfait",
				copy: "Copier",
				text: "Voulez-vous créer une copie de réservation?",
				placeholder: "Nom de la copie du forfait",
				errors: {
					inputs: "Les champs n'ont pas été remplis correctement.",
					name: "Le nom du forfait est identique au nom original.",
					length: "Le nom du forfait n'a pas atteint le nombre minimum de caractères.",
				},
			},
			modal: {
				title: "Émettre une facture pour {{name}}",
				issueInvoice: "Émettre une facture",
				fiscalProfile: "Profil fiscal",
				cpf: "NIR",
				cnpj: "SIRET",
				none: "Aucun",
				paymentMethod: "Méthode de paiement",
				fiscalGroup: "Groupe fiscal",
				ncm: "NCM",
				cest: "CEST",
				value: "Valeur",
				remove: "Supprimer",
				add: "Ajouter un groupe fiscal",
				tip: "Pourboire",
				removeTip: "Supprimer le pourboire",
				invoiceValue: "Valeur de la facture",
				invoiceAlert: "Les factures d'une valeur supérieure à €10.000 seront divisées.",
				alreadyIssuedInvoiceAlert: "Ce forfait a déjà des factures émises.",
				alreadyIssuedInvoiceConfirm:
					"Êtes-vous sûr de vouloir émettre ? Ce forfait a déjà des factures émises.",
				packageValue: "Valeur du forfait",
				discount: "Réductions",
				total: "Total",
				chooseOptions: "Choisissez l'une des options",
				addDiscount: "Ajouter des réductions à la facture",
				completeValue: "Compléter la valeur du forfait",
				recipientRazaoSocial: "Raison Sociale",
				recipientInscricaoEstadual: "Enregistrement Fiscal",
				recipientIndicador: "Indicateur d'Enregistrement Fiscal",
				recipientAddress: "Adresse",
				logradouro: "Rue",
				numero: "Numéro",
				complemento: "Complément",
				bairro: "Quartier",
				cep: "Code Postal",
				municipio: "Municipalité",
				uf: "Région",
				optionalTip: {
					title: "Pourboire (optionnel)",
					add: "Ajouter un pourboire",
				},
				inputMultiplePaymentsManual: {
					label: "Méthode de paiement",
					placeholder: "Sélectionner",
					value: "Valeur",
					add: "Ajouter un paiement",
				},
				errors: {
					value: "Incluez un produit avec une valeur pour utiliser cette fonctionnalité",
					inputs: "Les champs n'ont pas été remplis correctement",
				},
				invoiceProcessing: "La facture est en cours de traitement...",
				invoiceIssuingSoon: "La facture sera émise dans quelques instants",
				invoiceIssuedSuccess: "Facture émise avec succès",
			},
			tableMultiplePayment: {
				columns: {
					paymentMethod: "Méthode de paiement",
					value: "Valeur",
				},
				total: "Total ajouté",
			},
			peopleDidntArrive: {
				title: "Inconnu",
				subtitle: "Sans information",
			},
			peopleArrived: {
				title: "À l'événement",
				subtitle: "Déjà parti",
			},
		},
		reserveModal: {
			inactive: " (Promotion inactive)",
			edit: "Modifier le forfait",
			create: "Créer",
			newTemplate:
				"Attention! Le modèle créé pourra être utilisé par tous les événements de ce lieu.",
			template:
				"Le forfait peut être personnalisé, mais créera une association au modèle pour être utilisé dans les rapports et les métriques.",
			models: "Modèles",
			clientInfo: "Informations du client",
			name: "Nom",
			estimatedPeopleCount: "Nombre d'invités",
			value: "Valeur du forfait",
			expiresAt: "Expire le",
			promotion: "Promotion",
			promotionLabel: "Promotion {{number}}",
			updateModal: {
				promotionName: "Nom de la promotion",
				description: "Description",
				productName: "Nom du produit",
				percentage: "Pourcentage",
			},
			modalTitle: {
				edit: "Modifier {{name}}",
				newTemplate: "Créer un modèle",
				template: "Créer à partir du modèle",
				create: "Créer un forfait",
			},
			errors: {
				selectedTemplate: "Le modèle n'a pas pu être trouvé",
				promotion: "Aucune promotion sélectionnée",
				inputs: "Complétez tous les champs obligatoires pour la catégorie sélectionnée.",
			},
		},
		reserveOptions: {
			create: {
				name: "Créer un forfait personnalisé",
				label:
					"Définissez comment le forfait sera proposé et incluez une promotion si vous le souhaitez.",
			},
			createWithTemplate: {
				name: "Créer à partir du modèle",
				label:
					"Créez un forfait pour vos clients basé sur les modèles créés précédemment.",
			},
			createTemplate: {
				name: "Créer un nouveau modèle",
				label:
					"Créez un modèle de forfait personnalisé pour l'utiliser à l'avenir dans vos événements.",
			},
			canBeUsedIn: "Poura être utilisé dans",
			allEvents: "tous les événements",
			fromThisPlace: "de ce lieu",
			managePackages: "Gérer les forfaits",
		},
		reserveTemplate: {
			loading: "Chargement ...",
			empty: "Le lieu n'a aucun modèle enregistré.",
			remove: "Supprimer",
			value: "Valeur du forfait",
			guests: "Invités",
			promotions: "Promotions",
			modalConfirm: {
				title: "Êtes-vous sûr de vouloir supprimer le modèle?",
				content: "Il ne pourra plus être utilisé dans aucun événement de ce lieu.",
			},
		},
	},
	reserveReport: {
		label: "Rapport des forfaits",
		subtitle: {
			none: "Aucun forfait actif pendant l'événement",
			one: "un forfait actif pendant l'événement",
			default: "{{count}} forfaits actifs pendant l'événement",
		},
	},
};
